module.exports = __webpack_public_path__ + "img/preflang.f63316e3.svg";